import { AppRouter } from './router';
import { RootLayout } from './layouts/RootLayout';

export function App() {
  return (
    <RootLayout>
      <AppRouter />
    </RootLayout>
  );
}
